module.exports = __webpack_public_path__ + "static/img/8509c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dxdy/logo.png
// module id = 633
// module chunks = 2